export default __webpack_public_path__ + "media/images/icon_grade-8e81b8e88c2b5834347a2a226c65d440.svg";